import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

// Defaults mirror backend/site_config.py so the UI never flashes empty values.
const DEFAULT_CONFIG = {
  brand_name: "Eleven Family Office",
  brand_full: "Eleven Family Office",
  legal_name: "Eleven Family Office GmbH",
  street: "K\u00f6nigstra\u00dfe 27",
  zip_city: "70173 Stuttgart",
  country: "Deutschland",
  phone: "+49 (0) 711 000000-0",
  email: "anfrage@eleven-familyoffice.ch",
  register_info: "HRB 000000 \u00b7 Amtsgericht Stuttgart",
  calendly_url: "https://calendly.com/eleven-family-office/beratung",
  kpis: [
    { value: "10", label_de: "Jahre am Markt", label_en: "Years in the market" },
    { value: "250 Mio. \u20ac", label_de: "verwaltetes Verm\u00f6gen", label_en: "Assets under management" },
    { value: "50 Mio. \u20ac", label_de: "vermittelte Wohnimmobilien", label_en: "Residential property brokered" },
    { value: "1.000+", label_de: "Kunden & K\u00e4ufer", label_en: "Clients & buyers" },
  ],
};

const SiteConfigContext = createContext(DEFAULT_CONFIG);

export function SiteConfigProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);

  useEffect(() => {
    let mounted = true;
    api
      .get("/public/site-config")
      .then((res) => {
        if (mounted && res.data) setConfig((prev) => ({ ...prev, ...res.data }));
      })
      .catch(() => {
        /* keep defaults */
      });
    return () => {
      mounted = false;
    };
  }, []);

  return <SiteConfigContext.Provider value={config}>{children}</SiteConfigContext.Provider>;
}

export const useSiteConfig = () => useContext(SiteConfigContext);
